var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpillTop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "9 0 49 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.1064,
    y: 7.01144,
    width: 12,
    height: 12,
    transform: "rotate(70.1516 12.1064 7.01144)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22.7164,
    y: -10.2812,
    width: 15.4592,
    height: 15.4592,
    transform: "rotate(101.584 22.7164 -10.2812)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15.6113,
    y: 24.3413,
    width: 7.24217,
    height: 7.24217,
    transform: "rotate(38.6153 15.6113 24.3413)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 27.6036,
    y: 18.886,
    width: 4.70446,
    height: 4.70446,
    transform: "rotate(99.2373 27.6036 18.886)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 23.9115,
    y: 7.9841,
    width: 4.70446,
    height: 4.70446,
    transform: "rotate(61.6179 23.9115 7.9841)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 33.1551,
    y: 13.3007,
    width: 2.2272,
    height: 2.2272,
    transform: "rotate(61.6179 33.1551 13.3007)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 45.904,
    y: 10.1385,
    width: 2.2272,
    height: 2.2272,
    transform: "rotate(-4.00091 45.904 10.1385)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 31.1956,
    y: 2.71124,
    width: 2.2272,
    height: 2.2272,
    transform: "rotate(61.6179 31.1956 2.71124)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpillTop);
export default __webpack_public_path__ + "static/media/spill-top.a384892fe6e2b4ce2d49953dc2927e7b.svg";
export { ForwardRef as ReactComponent };